import React, { useEffect, useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, message, Modal, Radio } from '@drip/drip-design';
import './index.less';
import '@jd/jmtd-charts/dist/themes/default.css'; // 默认皮肤
import '../yx.css';
import '../yx-pro.css';
import '../yx-extra.css';
import apis from '../../apis';
import {FormGroup, Summary, SummaryCardTitle, SummaryCardIndex, SummaryCardDescription, GridSummary, ColorSummaryCard, DropdownCheckboxGroup } from '@jd/jmtd-pro';
import { CardSection, Button, Loading, Space, RadioButtonGroup, RadioGroup } from '@jd/jmtd';
import RealtimeCmpGroup from "./time/RealtimeCmpGroup";
import GeRealtimeGroup from "../sales-effect/time/GeRealtimeGroup";
import trafficComboTimePicker from "./time/offlineTimeCompare";
import { formatDate, addDate } from '@jd/jmtd-tools/es/date';
import { format } from '@jd/jmtd-tools/es/number';
import { NormalLineChart } from '@jd/jmtd-charts';
import moment from 'moment';
import { dropdownCheckboxDataV2, defaultCheckboxIndex, summaryList, getJmtdValFormatter, getSummaryData, indexIdList, timeGranularityList, chartConfig, userType } from './config'
import _ from 'lodash';

function SummaryRender({ data, name, des, type, norms=[] }) {
  return (
    <ColorSummaryCard>
      <SummaryCardTitle info={des}>{name}</SummaryCardTitle>
      <SummaryCardIndex>{_.isNil(data) ? '--' : format(data, getJmtdValFormatter(type))}</SummaryCardIndex>
      {
        norms.map(item => (
          <SummaryCardDescription
            key={item.code}
            left={item.name}
            right={_.isNil(item.value) ? '--' :  format(Math.abs(item.value), getJmtdValFormatter(item.type))}
            ascend={item.value > 0}
            descend={item.value < 0}
          />
        ))
      }
    </ColorSummaryCard>
  );
}
SummaryRender.propTypes = {
  circle: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default function (props) {
  const [data, setData] = useState();
  const [param, setParam] = useState({ready:false});
  const [dataType, setDataType] = useState('REALTIME'); //real-time:实时，offline-time，离线
  // 选中指标卡
  const [selectCard, setSelectCard] = useState(defaultCheckboxIndex[0]);
  // 选中指标
  const [selectedIndex, setSelectedIndex] = useState(defaultCheckboxIndex);
  const [summaryLoading, setSummaryLoading] = useState(false);
  // 实时趋势图类型
  const [trendType, setTrendType] = useState(0);
  const [resetKey, setResetKey] = useState(0);
  const [visible, setVisible] = useState(false);

  const userTypeRef = useRef();
  const dateTypeRef = useRef();

  const { indexList, idList=[] } = useMemo(() => {
    if (!props.filter) return dropdownCheckboxDataV2(dataType, userType.DEPT);
    return dropdownCheckboxDataV2(dataType, props?.filter?.userType)
  }, [dataType, props?.filter?.userType])

  const changeIndicator = selected => {
    const selectedIndex = selected.slice();
    let indexFlat = selectedIndex.flat();
    indexFlat = _.intersection(indexIdList, indexFlat);
    setSelectedIndex(indexFlat);
    const selectedCard = indexFlat.slice(0, 1);
    setSelectCard(selectedCard[0]);
    setResetKey(new Date().getTime());
  };

  const onHeaderReadyAndChange = (ctx) => {
    const { getFields } = ctx;
    const header = getFields('Header');
    console.log({ header })
    let beginDate, endDate, cBeginDate, cEndDate, excelName;
    //处理实时离线
    if (header.inRealtime) {
      beginDate = header.rangeStartTime;
      endDate = header.rangeEndTime;
      cBeginDate = header.rangeCompareStartTime;
      cEndDate = header.rangeCompareEndTime;
      excelName = header.customCompareType === 'yoy' ? '同比' : header.customCompareType === 'dod' ? '环比' : '自定义对比'
    } else {
      excelName = header.compareType == 1 ? '同比' : '环比'
      if (header.dateType === 'day') {
        beginDate = endDate = header.date;
        cBeginDate = header.compareStartDate;
        cEndDate = header.compareEndDate
      } else if (header.dateType === 'range') {
        [beginDate, endDate] = header.date;
        cBeginDate = header.compareStartDate.split('~')?.[0];
        cEndDate = header.compareStartDate.split('~')?.[1];
      }
    }
    let currentParams = {
      ready: true,
      dataType: header.inRealtime ? 'REALTIME' : 'OFFLINE',
      beginDate,
      endDate,
      cBeginDate,
      cEndDate,
      excelName

    }
    setDataType(header.inRealtime ? 'REALTIME' : 'OFFLINE')
    setParam(currentParams)
  }

  //函数组件创建时只执行一次，避免group组件多次渲染问题
  const[group] = useState(() => FormGroup({
    onReady: onHeaderReadyAndChange,
    onChange: onHeaderReadyAndChange,
    groups: {
      Header: {
        noFormWrap: true,
        ...GeRealtimeGroup({
          realtime: {
            label: '时间',
            ...RealtimeCmpGroup().fields[0]
          },
          offline: trafficComboTimePicker(),
          defaultInRealtime: true
        }),
      }
    }
  }))


  const groupRef = useRef(group);
  const {Groups} = groupRef.current;
  useEffect(() => {
    if (!props.filter || !param.ready) return;
    // 对于按日筛选日历，即beginDate == endDate，endDate要取-15，因为趋势图传给后端的是日期范围
    let currentParams = _.omit(param, 'ready','excelName');
    setSummaryLoading(true);

    if(_.isEmpty(userTypeRef.current)){
      userTypeRef.current = props?.filter?.userType;
    }
    if(_.isEmpty(dateTypeRef.current)){
      dateTypeRef.current = param.dataType;
    }
    let _selectedIndex = selectedIndex;
    let _selectCard = selectCard;
    if(userTypeRef.current != props?.filter?.userType){
      setSelectedIndex(defaultCheckboxIndex)
      setSelectCard(defaultCheckboxIndex[0])
      userTypeRef.current = props?.filter?.userType;
      _selectedIndex = defaultCheckboxIndex;
      _selectCard = defaultCheckboxIndex[0]
    }
    if(dateTypeRef.current != param.dataType){
      setSelectedIndex(defaultCheckboxIndex)
      setSelectCard(defaultCheckboxIndex[0])
      dateTypeRef.current = param.dataType;
      _selectedIndex = defaultCheckboxIndex;
      _selectCard = defaultCheckboxIndex[0]
    }
    apis
      .participantServiceQueryHomeIndex({ ...props.filter,
        erpNo: props.erp,
        timeInterval: dataType === 'REALTIME'? 'BY_HOUR': 'BY_DAY',
        trendType: dataType === 'REALTIME'? trendType : 0,
        ...currentParams,
        indicators:_selectedIndex,
        trendIndex: _selectCard,
        beginDate: currentParams.beginDate === currentParams.endDate ? formatDate(addDate(new Date(currentParams.beginDate), -14, 'day'), 'YYYY-MM-DD') : currentParams.beginDate,
        cBeginDate: currentParams.cBeginDate === currentParams.cEndDate ? formatDate(addDate(new Date(currentParams.cBeginDate), -14, 'day'), 'YYYY-MM-DD') : currentParams.cBeginDate
      })
      .then((res) => {
        const { ret, data, msg } = res;
        if (ret === '0') {
          setData(data);
          setSummaryLoading(false);
        } else {
          message.error(msg);
          setData({});
          setSummaryLoading(false);
        }
      });
  }, [props.filter, param, resetKey, trendType]);

  const dataSourceNew = useMemo(() => getDataNew(data), [data]);

  const summaryData = useMemo(() => getSummaryData(data, selectedIndex), [data]);

  const downLoad = async () => {
    // 对于按日筛选日历，即beginDate == endDate，endDate要取-15，因为趋势图传给后端的是日期范围
    let currentParams = _.omit(param, 'ready');
    // message.warn('因功能限制，暂不支持部门站内新和部门站外新指标数据下载。', 5);
    apis
      .participantServiceQueryHomeIndex({ ...props.filter,
        erpNo: props.erp,
        timeInterval: dataType === 'REALTIME'?'BY_HOUR': 'BY_DAY',
        trendType: dataType === 'REALTIME'? trendType : 0,
        ...currentParams,
        // indicators:selectedIndex,
        // trendIndex: selectCard,
        beginDate: currentParams.beginDate === currentParams.endDate ? formatDate(addDate(new Date(currentParams.beginDate), -14, 'day'), 'YYYY-MM-DD') : currentParams.beginDate,
        cBeginDate: currentParams.cBeginDate === currentParams.cEndDate ? formatDate(addDate(new Date(currentParams.cBeginDate), -14, 'day'), 'YYYY-MM-DD') : currentParams.cBeginDate,
        download: true,
        indicator: idList
      })
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || '导出失败，请稍后重试';
        message.success('导出成功，稍后将会用鲸盘分享给您');
      })
      .catch((ex) => {
        message.error(ex);
      });
  }

  if (!data || JSON.stringify(data) === '{}') return null;

  return (
    <div className="global-effect-card-bg">
      <div>
        <div className="global-effect-title">
          <span>
            数据概览{' '}
            <span className="global-effect-subtitle">
              更新时间：
              {dataType === 'REALTIME'
                ? moment().format('YYYY-MM-DD HH:mm:ss')
                : moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')}
            </span>
          </span>
          <span className="global-effect-time-change">
            <Groups.Header />
          </span>
        </div>
        <div className="global-effect-card">
          <Space>
            <Button semantic='primary' onClick={() =>  downLoad().then(r => r)}>
              导出数据
            </Button>
            {
              indexList.length > 0 &&
              <DropdownCheckboxGroup
                key={`${JSON.stringify(indexList)}`}
                width={716}
                value={selectedIndex}
                onChange={changeIndicator}
                data={indexList}
                maxLength={4}
                resetValue={defaultCheckboxIndex}
              >
                <Button semantic='primary'>
                  指标切换
                </Button>
              </DropdownCheckboxGroup>
            }
          </Space>

        </div>
        <Loading loading={summaryLoading}>
          <CardSection>
            <Summary
              value={selectCard}
              onChange={(value)=>{setSelectCard(value);  setResetKey(new Date().getTime());}}
              controlType='radio'
              data={summaryData}
              size={'small'}
              itemRender={SummaryRender}
              render={GridSummary}
            />
          </CardSection>
          <CardSection>
            {
              dataType === 'REALTIME' &&
              <div className={'global-effect-card'}>
                <RadioGroup
                  outline
                  render={RadioButtonGroup}
                  data={timeGranularityList}
                  value={trendType}
                  onChange={setTrendType}
                />
              </div>
            }
            <NormalLineChart {...chartConfig()} data={dataSourceNew} height={270}/>
          </CardSection>
        </Loading>
        <Modal
          width={360}
          title="导出数据"
          visible={visible}
          footer={null}
          onCancel={() => {
            setVisible(false);
          }}
          okText="导出"
          destroyOnClose
        >
          <div>
            提示：功能限制，暂不支持部门站内新和部门站外新指标数据下载，其余指标可正常下载
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
            <Button semantic='primary' style={{ marginRight: 16 }} onClick={() => {setVisible(false); downLoad().then(r => r);}}>
              导出
            </Button>
            <Button onClick={() => setVisible(false)}>取消</Button>
          </div>
        </Modal>
      </div>
    </div>
  );

  function getDataNew(data) {
    if (!data || !data.trendList || (data.trendList && !data.trendList.length))
      return {
        series: [],
        categories: [],
      };
    const temData = data.trendList;
    const temChartData = {
      series: [
        {
          code: summaryList[selectCard].value,
          data: [],
          name: summaryList[selectCard].name,
          type: getJmtdValFormatter(summaryList[selectCard].type),
        },
        {
          code: `${selectCard}_ratio`,
          data: [],
          name: '较对比日',
          type: 'percent_2_0_1',
          yAxisIndex: 1,
        },
      ],
      categories: [],
    };

    temData.forEach((item) => {
      temChartData.categories.push(item.point || item.dt);
      temChartData.series.forEach((cateItem) => {
        cateItem.data.push(
          item[cateItem.code] === null || item[cateItem.code] === undefined ? null : item[cateItem.code]
        );
      });
    });
    return temChartData;
  }
}
